import React from "react";
import { BaseAttributeViewProps } from "./BaseAttributeViewProps";

export interface TextAttributeViewProps extends BaseAttributeViewProps {}

export const TextAttributeView = ({ value }: TextAttributeViewProps) => {
  return <div>{String(value)}</div>;
};
